import React from 'react';
import { ImportantDatesFeature } from './components/ImportantDates';
export function App() {
  return <ImportantDatesFeature data-id="element-0" />;
}